/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Visa: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <rect width='32' height='32' rx='16' fill='#1A1F71' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='m10.21 12.4-1.9 4.89L7.43 13c-.12-.45-.46-.59-.88-.6H3.43l-.03.14c.76.19 1.44.46 2.03.79l1.73 6.25h2.05l3.06-7.19H10.2Zm15.74 0h-1.5c-.46 0-.81.13-1.01.6l-2.88 6.59h2.03l.41-1.2h2.48l.24 1.2h1.8l-1.57-7.19Zm-2.4 4.48.78-1.85.08-.2.18-.48.13.62.45 1.91h-1.61Zm-4.48-4.47a5 5 0 0 1 1.74.3l-.26 1.54-.18-.08a3.58 3.58 0 0 0-1.45-.27c-.76 0-1.1.32-1.1.61-.01.34.4.56 1.08.88 1.12.51 1.64 1.02 1.63 1.83-.02 1.48-1.34 2.38-3.38 2.38-.87 0-1.7-.18-2.16-.38l.27-1.6.25.12c.64.26 1.05.37 1.83.37.56 0 1.16-.16 1.16-.64 0-.31-.25-.53-1-.88-.74-.34-1.72-.8-1.7-1.83 0-1.38 1.36-2.35 3.27-2.35Zm-6.02 0-1.21 7.18h1.94l1.21-7.19h-1.94Z'
      fill='#fff'
    />
  </React.Fragment>
)
